@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

$button-text-color: v.$palette-accent;
$button-background-color: v.$palette-future-accent;
$text-color: v.$palette-gray-900;

.modal {
  padding: 0;
  margin: 0;
  max-width: 420px;
  width: calc(100% - 30px);
}

.content {
  padding: 40px;
  text-align: initial;
  display: flex;
  flex-direction: column;
}

.sealinesList,
.buttonsWrapper {
  margin-top: 24px;
}

.title {
  color: $text-color;
  @include t.text(18px, 22px, 600);
}

.button {
  border: none;
  outline: none;
  appearance: none;
  cursor: pointer;
  &::-moz-focus-inner {
    border: 0;
  }

  background-color: $button-background-color;
  border-radius: 6px;
  padding: 4px 27px;

  @include t.text(14px, 24px, 600);
  color: $button-text-color;
}

.buttonsWrapper {
  display: flex;
  align-items: center;
  align-self: flex-end;

  .button + .button {
    margin-left: 8px;
  }
}

.changeShippingLineModalLoading {
  width: 420px;
  padding: 62px 57px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: initial;
}


.loadingText {
  margin-top: 32px;
  color: $text-color;
  text-align: center;
  @include t.text(16px, 26px, 400);
}

.changeShippingLineModalError {
  width: 100%;
  padding: 24px;
  text-align: center;
  position: relative;

  .closeIcon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    opacity: 0.3;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }

    &:before, &:after {
      position: absolute;
      left: 11px;
      content: "";
      height: 25px;
      width: 3px;
      background-color: $text-color;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

.errorText {
  margin-top: 16px;
  color: $text-color;
  @include t.text(16px, 20px, 600);
}
